import { forwardRef, useContext } from "react";
import { OTPInputContext } from "input-otp";
import { InputOTP, InputOTPGroup } from "@/components/ui/input-otp";
import { cn } from "@/lib/utils";

const AuthOtpSlot = forwardRef(({ index, className, ...props }, ref) => {
  const inputOTPContext = useContext(OTPInputContext);
  const { char, hasFakeCaret, isActive } = inputOTPContext.slots[index];
  const displayChar = char ? "*" : "";

  return (
    <div
      ref={ref}
      className={cn(
        "relative flex h-11 w-11 items-center justify-center overflow-hidden rounded-xl border border-primary/45 bg-muted text-xl font-semibold leading-none text-primary shadow-none transition-colors min-[380px]:h-12 min-[380px]:w-12 min-[380px]:text-2xl",
        isActive && "z-10 border-primary/45 bg-muted",
        className
      )}
      {...props}
    >
      <span
        className={cn(
          "absolute inset-0 flex items-center justify-center leading-none",
          char && "translate-y-0.5",
          !char && "text-muted-foreground/45"
        )}
      >
        {displayChar}
      </span>
      {hasFakeCaret ? (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div className="h-5 w-px animate-caret-blink bg-primary duration-1000" />
        </div>
      ) : null}
    </div>
  );
});

AuthOtpSlot.displayName = "AuthOtpSlot";

export default function AuthOtpInput({ className, value, onChange, ...props }) {
  return (
    <InputOTP
      maxLength={4}
      value={value}
      onChange={onChange}
      containerClassName={cn("max-w-full gap-2 min-[380px]:gap-2.5", className)}
      {...props}
    >
      <InputOTPGroup className="max-w-full gap-2 min-[380px]:gap-2.5">
        {[0, 1, 2, 3].map((index) => (
          <AuthOtpSlot key={index} index={index} />
        ))}
      </InputOTPGroup>
    </InputOTP>
  );
}
